import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { Routing } from "../data/Constants/Routing";
import CreateRoleScreen from "./Role/CreateRoleScreen";
import EditRoleScreen from "./Role/EditRoleScreen";
import RoleScreen from "./Role/RoleScreen";
import ScenarioScreen from "./Scenario/ScenarioScreen";
import CreateScenarioScreen from "./Scenario/CreateScenarioScreen";
import EditScenarioScreen from "./Scenario/EditScenarioScreen";
import ExecutionScreen from "./Execution/ExecutionScreen";
import EditExecutionScreen from "./Execution/EditExecutionScreen";
import WorkerScreen from "./Worker/WorkerScreen";

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: theme.palette.background.default,
        borderTop: `1px solid ${theme.palette.divider}`,
        overflowY: "hidden",
        minWidth: "1250px",
        userSelect: "text"
    },
    container: {
        width: "100%",
        padding: "0 2rem",
        flexGrow: 1,
        minWidth: "1200px",
        maxWidth: "1440px",
        display: "flex"
    },
    content: {
        flexGrow: 1,
        maxHeight: "calc(100vh - 60px - 1px)", // 1px for the border bottom of the menu
        overflowY: "auto",
        padding: "2rem 2rem 0 2rem",
        display: "flex",
        flexDirection: "column"
    }
}));

const AdministrationScreen: React.FC = () => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <div className={classes.container}>
                <div className={classes.content}>
                    <Routes>

                        {/* EXECUTION ROUTES */}
                        <Route
                            path={Routing.Administration.Execution.Edit.Route}
                            element={<EditExecutionScreen />} />
                        <Route
                            path={Routing.Administration.Execution.Route}
                            element={<ExecutionScreen />} />
                        <Route
                            path={Routing.Administration.Execution.Redirect}
                            element={<Navigate replace to={Routing.Administration.Execution.Navigate()} />} />

                        {/* SCENARIO ROUTES */}
                        <Route
                            path={Routing.Administration.Scenario.Create.Route}
                            element={<CreateScenarioScreen />} />
                        <Route
                            path={Routing.Administration.Scenario.Edit.Route}
                            element={<EditScenarioScreen />} />
                        <Route
                            path={Routing.Administration.Scenario.Route}
                            element={<ScenarioScreen />} />
                        <Route
                            path={Routing.Administration.Scenario.Redirect}
                            element={<Navigate replace to={Routing.Administration.Scenario.Navigate()} />} />

                        {/* ROLE ROUTES */}
                        <Route
                            path={Routing.Administration.Role.Create.Route}
                            element={<CreateRoleScreen />} />
                        <Route
                            path={Routing.Administration.Role.Edit.Route}
                            element={<EditRoleScreen />} />
                        <Route
                            path={Routing.Administration.Role.Route}
                            element={<RoleScreen />} />
                        <Route
                            path={Routing.Administration.Role.Redirect}
                            element={<Navigate replace to={Routing.Administration.Role.Navigate()} />} />

                        {/* WORKER ROUTES */}
                        <Route
                            path={Routing.Administration.Worker.Route}
                            element={<WorkerScreen />} />
                        <Route
                            path={Routing.Administration.Worker.Redirect}
                            element={<Navigate replace to={Routing.Administration.Worker.Navigate()} />} />

                    </Routes>
                </div>
            </div>
        </div>
    );
};

export default AdministrationScreen;
